export default __webpack_public_path__ + "static/flexing-7fa371642b67767aff2b95764216f8dd.png";